<template>
  <component :is="iconComponent" v-bind="getBindValue" />
  <!-- <CircleIcon /> -->
</template>

<script lang="ts" setup>
import { defineAsyncComponent, computed, PropType, useAttrs } from 'vue'
// import CircleIcon from 'tdesign-icons-vue-next/lib/components/circle'

const props = defineProps({
  name: {
    type: String as PropType<string>,
    required: true
  },
  size: {
    type: String as PropType<string>,
    default: '24px'
  },
  color: {
    type: String as PropType<string>,
    default: '#000'
  }
})

const attrs = useAttrs()

const getBindValue = computed(() => ({ ...attrs }))

const iconComponent = computed(() => {
  return props.name + '-icon'
})
</script>

<style scoped>
/* 你可以在这里添加一些样式 */
</style>
